import React from "react";

const Tooltip = (props) => {
  let message = [];
  let required_msg = "This field is required.";
  (props.required === true) && message.push(required_msg);
  let space = "This field does not allow space.";
  let fileType = "This field allows only Text files.";
  let allowedLength = props.charLength ? `This field allows more than ${props.charLength} characters.` : '';
  let specialCharNum = "This field does not allow numbers and special characters.";
  let specialCharException = props.specialCharException !== undefined ? `This field does not allow special characters except ${props.specialCharException}` : "";
  let pdfFile = "This field allows only PDF files.";
  let firmwareFileType = "This field allows only .zip/.tar files.";
  let componentTypeCode = `Please ensure firmware version ${props.componentName?.toUpperCase().includes("COMPASS FIXTURE") ? " starts with production_ and " : ""} includes the required component code: ${props.code}.`;
  let fileNameException = `File name does not allow space.`;
  let domainSelection = "Please select a domain from the suggestions.";
  switch (props.type) {
    case "otis_id":
      message.push("Please enter a valid otis email id. For example,'John.doe@otis.com'");
      break;
    case "username":
      message.push(allowedLength, specialCharNum);
      break;
    case "version":
      message.push(specialCharException, componentTypeCode);
      break;
    case "file":
      message.push(firmwareFileType, specialCharException,fileNameException);
      break;
    case "release_notes":
      message.push(fileType, "Please select a Release Notes.");
      break;
    case "sitename":
      message.push(specialCharException);
      break;
    case "customerid":
      message.push("Please enter a valid Customer Email id. For example, 'John.doe@xyz.com'", domainSelection);
      break;
    case "address":
      message.push(specialCharException);
      break;
    case "state":
      message.push(specialCharNum);
      break;
    case "rejection_reason":
      message.push(allowedLength);
      break;
    case "site_selection":
      message.push("Please select a Site");
      break;
    case "componentType_selection":
      message.push("Please select a Component Type");
      break;
    case "contract_number":
      message.push(space, allowedLength, specialCharException);
      break;
    case "contracts":
      message.push("Please select a Contract Number");
      break;
    case "network_diagram":
      message.push(pdfFile, "Please select a Network Diagram.");
      break;
    case "domain":
      message.push("One or more of the domains you entered are restricted.");
      break;
    default:
      message = "";
  }

  let messageDisplay = message.map((msg, i) => (
    <li key={i * 1}>
      {msg}
    </li>
  ))

  return (
    <>
      {message.length === 1 ? (
        <div
          className="invalid-tooltip d-block"
          style={{
            position: "initial",
            backgroundColor: "#ffe6e6",
            borderLeft: "4px solid #dc3545",
            color: "#8b3a3a",
            padding: "10px 12px",
            borderRadius: "4px",
            fontSize: "0.875rem",
            marginTop: "0.5rem",
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}
          role="application"
          aria-describedby={message}
        >
          <span>{message}</span>
        </div>
      ) : (
        <div
          className="invalid-tooltip d-block"
          style={{
            position: "initial",
            backgroundColor: "#ffe6e6",
            borderLeft: "4px solid #dc3545",
            color: "#8b3a3a",
            padding: "10px 12px",
            borderRadius: "4px",
            fontSize: "0.775rem",
            marginTop: "0.5rem"
          }}
          role="application"
          aria-describedby={messageDisplay}
        >
          <div style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
            <ul style={{ margin: 0, paddingLeft: "1.25rem" }}>
              {messageDisplay}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};


export default Tooltip;
